export enum AssetType {
    USER_PHOTO = 'UserPhoto',
}
